import * as React from 'react';
import * as _ from 'lodash';
import * as qs from 'query-string';
import * as moment from 'moment';
import { connect, Dispatch } from 'react-redux';
import { IApplicationState, AppActionCreators, TargetActionCreators, IDonorsPerMonthByAboResponse, MatchingActionCreators, IMatchRunScenariosResponse, IGetAllNewResponse } from '@nkr/store/index';
import { IEwtSummary, IFwtSummary, IBaseResponse, IUser, ITargetItem, IDonorsPerMonthByAbo, IMatchRunScenario, IMatchRunGroup, IMatchRunDiagnostics, IVoucherScenarioItem, IMortalityCalculations } from '@nkr/models/index';
import { TargetCheckTypeNew } from '@nkr/enums/index';
import Tabs from '@nkr/views/swap-management/tabs-new';
import EwtDetails from './modals/ewt-details';
import FwlDetailsModal from './modals/fwt-details-modal';
import TriggerRexm from './modals/trigger-rexm';
import BestMatchOptions from './best-match-options';
import { toast } from 'react-toastify';
import { Utility } from '@nkr/services/utility';
import PatientList from './patient-list';
import { ListType } from './list-type';
import { ISuppress } from './suppress';
import { TargetsContentWrapper } from './styles';
import { GridApi, GridReadyEvent } from 'ag-grid-community';
import { exportMultipleSheetsAsExcel } from 'ag-grid-enterprise';
import { Button } from 'react-bootstrap';
import MortalityBreakdown from '@nkr/components/mortality-breakdown-modal';

interface IOwnProps { }

interface IStateProps {
    token: string,
    user: IUser
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getAllNew: () => Promise<IGetAllNewResponse>,
    getDonorsPerMonthByAbo: () => Promise<IDonorsPerMonthByAboResponse>,
    getScenariosNew: () => Promise<IMatchRunScenariosResponse>,
    sendRexmEmail: (donorId: number, recipientId: number) => Promise<IBaseResponse>,
    updateClc: () => Promise<IBaseResponse>
}

type TProps =
    IOwnProps
    & IStateProps
    & IDispatchProps;

interface IState {
    hardToMatchList: ITargetItem[],
    voucherList: ITargetItem[],
    pairedPatientList: ITargetItem[],
    donorsPerMonthByAbo: IDonorsPerMonthByAbo,
    groups: IMatchRunGroup[],
    scenarios: IMatchRunScenario[],
    voucherScenarioMap: IVoucherScenarioItem[],
    adp: boolean,
    ewt: {
        show: boolean,
        ewtSummary: IEwtSummary,
        initialCount: { [key: string]: number, O: number, A: number, B: number, AB: number }
    },
    rexmEmail: {
        show: boolean,
        donorId: number,
        donorAlias: string,
        donorCenter: string,
        recipientId: number,
        recipientAlias: string,
        recipientCenter: string
    },
    checkedTargets: number[],
    checkedChainEndTargets: number[],
    suppress: ISuppress,
    waitTime: number,
    loadDateTime: string,
    uuid: string,
    fullSize: boolean,
    gridApis: GridApi[],
    mortalityBreakdown: {
        show: boolean,
        recipientAlias: string,
        data: IMortalityCalculations
    },
    fwt: {
        show: boolean,
        fwtSummary: IFwtSummary
    }
}

class Target extends React.Component<TProps, IState> {
    readonly state: IState = {
        hardToMatchList: [],
        voucherList: [],
        pairedPatientList: [],
        donorsPerMonthByAbo: null,
        groups: [],
        scenarios: [],
        voucherScenarioMap: [],
        adp: true,
        ewt: {
            show: false,
            ewtSummary: null,
            initialCount: null
        },
        rexmEmail: {
            show: false,
            donorId: 0,
            donorAlias: '',
            donorCenter: '',
            recipientId: 0,
            recipientAlias: '',
            recipientCenter: ''
        },
        checkedTargets: [],
        checkedChainEndTargets: [],
        suppress: {
            hardToMatch: true,
            voucher: true,
            pairedPatient: true,
        },
        waitTime: 0,
        loadDateTime: '',
        uuid: '',
        fullSize: false,
        gridApis: [],
        mortalityBreakdown: {
            show: false,
            recipientAlias: '',
            data: null
        },
        fwt: {
            show: false,
            fwtSummary: null
        }
    }

    onGridReady = (e: GridReadyEvent) => {
        this.setState({
            gridApis: [...this.state.gridApis, e.api]
        });
    }

    componentWillMount = () => {
        this.getData();

        document.title = 'NKR Admin: Targets';
    }

    getData = () => {
        let parsed = qs.parse(window.location.search);
        let scenarioId = parsed.scenario != null ? parseInt(parsed.scenario) : 0;
        let uuid = Utility.uuidv4();

        this.props.showLoading('Retrieving target data, one moment please...').then(() => {
            Promise.all([
                this.props.getAllNew(),
                this.props.getDonorsPerMonthByAbo(),
                this.props.getScenariosNew()
            ]).then(([allResponse, donorsPerMonthByAboResponse, scenarioResponse]) => {
                let { hardToMatchList, voucherList, pairedPatientList } = allResponse.data.results;
                let donorsPerMonthByAbo = donorsPerMonthByAboResponse.data.results;
                let { groups, scenarios, voucherScenarioMap } = scenarioResponse.data.results;               

                this.setState({
                    hardToMatchList, voucherList, pairedPatientList,
                    donorsPerMonthByAbo,
                    groups,
                    scenarios,
                    voucherScenarioMap,
                    loadDateTime: moment().format(),
                    uuid
                }, () => {
                    if (scenarioId >= 0) {
                        let scenario = this.state.scenarios.find(x => x.id == scenarioId);

                        if (scenario != null) {
                            this.handleRunScenario(scenario, true);
                        }
                    }
                });

                this.props.hideLoading();
            });
        });
    }

    getDiagnosticData = (): IMatchRunDiagnostics => {
        // let { voucherList, loadDateTime: targetsPageLoadDateTime } = this.state;
        // let highPriorityTargetedChainEnds = targetedChainEnds.filter(x => x.majorSort < 3 || x.pediatric);
        // let lowerPriorityTargetedChainEnds = targetedChainEnds.filter(x => x.majorSort >= 3 && !x.pediatric);

        // var targetsPageMiracleMatches = _.uniq(this.state.miracleMatches.map(x => x.recipientId));
        // let targetsPagePriority12 = highPriorityTargetedChainEnds.map(x => x.recipientId);
        // let targetsPagePriority14 = lowerPriorityTargetedChainEnds.filter(x => x.majorSort >= 1 && x.majorSort <= 4).map(x => x.recipientId);
        // let targetsPagePriority15 = lowerPriorityTargetedChainEnds.filter(x => x.majorSort >= 1 && x.majorSort <= 5).map(x => x.recipientId);

        // var data: IMatchRunDiagnostics = {
        //     targetsPageMiracleMatches,
        //     targetsPagePriority12,
        //     targetsPagePriority14,
        //     targetsPagePriority15,
        //     targetsPageLoadDateTime,
        //     matchRunMiracleMatches: [],
        //     matchRunPriority12: [],
        //     matchRunPriority14: [],
        //     matchRunPriority15: []
        // };

        // return data;

        return null;
    }

    getTimeDateString = () => {
        let now = new Date();

        let year = now.getFullYear();
        let month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        let day = String(now.getDate()).padStart(2, '0');
        let hours = String(now.getHours()).padStart(2, '0');
        let minutes = String(now.getMinutes()).padStart(2, '0');
        let seconds = String(now.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
    }

    gotoBm3 = (scenario: number, rerun: boolean) => {
        let diagnostics = this.getDiagnosticData()

        localStorage.setItem('bm-diagnostics-' + this.state.uuid, JSON.stringify(diagnostics));

        let targets = this.state.checkedTargets.length == 0 ? '' : this.state.checkedTargets.join(',');
        let chainEndTargets = this.state.checkedChainEndTargets.length == 0 ? '' : this.state.checkedChainEndTargets.join(',');

        if (!rerun) {
            window.open(`/matching/match-run/configure-new?scenario=${scenario}&targets=${targets}&chainEndTargets=${chainEndTargets}&uuid=${this.state.uuid}`, '');
        } else {
            window.location.href = `/matching/match-run/configure-new?scenario=${scenario}&targets=${targets}&chainEndTargets=${chainEndTargets}&uuid=${this.state.uuid}`;
        }
    }

    handleUpdateClc = () => {
        this.props.showLoading('Updating CLC, one moment please...').then(() => {
            this.props.updateClc().then(response => {
                this.props.hideLoading();

                if (response.data.success) {
                    toast.success('Successfully updated CLC');
                } else {
                    toast.error('Could not update CLC');
                }
            });
        });
    }

    handleShowEwt = (summary: IEwtSummary, initialCount: any) => {
        this.setState({
            ewt: {
                show: true,
                ewtSummary: summary,
                initialCount
            }
        });
    }

    handleEwtClose = () => {
        this.setState({
            ewt: { ...this.state.ewt, show: false }
        });
    }

    handleShowFwt = (recipient: ITargetItem) => {
        let isHardToMatch = recipient?.hardToMatch;
        let isVoucherHolder = recipient?.isVoucherHolder;
        let isPaired = recipient?.isPairedRecipient;

        let fwtSummary: IFwtSummary = {
            recipientId: recipient.recipientId,
            recipientAlias: recipient.recipientAlias,
            hardToMatch: isHardToMatch,
            isVoucherHolder,
            isPairedRecipient: isPaired,
            patientCpra: recipient?.cPRA4 ?? 0,
            patientHistoricalDeclineRatio: recipient?.declineRatioHistoric ?? 0,
            donorsNeeded: recipient?.donorsNeeded ?? 0,
            aboCombo: recipient?.aboCombo ?? '',
            donorsCompatibleABO: recipient?.donorCompatibleAbo.toString() ?? '',
            aboAndAgeCompatibleDonors: recipient?.aboAndAgeCompatibleDonors.toString() ?? '',
            recipientBloodType: recipient?.recipientBloodType ?? '',
            categories: recipient?.categories ?? [],
            fwt: recipient?.forecastedWaitTime.toString() ?? '',
            ewt: recipient?.wait.toString() ?? '',
            awt: recipient?.aWait.toString() ?? '',           
            age: recipient?.rAge ?? 0   
        };

        this.setState({
            fwt: {
                show: true,
                fwtSummary
            }
        });
    }

    handleFwtClose = () => {
        this.setState({
            fwt: { ...this.state.fwt, show: false }
        });
    }

    handleOpenEWTPage = (recipientId: number) => {
        let combinedList = [
            ...this.state.hardToMatchList.map(x => ({ ...x, bucket: 'HTM' })),
            ...this.state.voucherList.map(x => ({ ...x, bucket: 'VL' })),
            ...this.state.pairedPatientList.map(x => ({ ...x, bucket: 'PairedPatient' })),
        ];

        let recipient = combinedList.find(x => x.recipientId == recipientId);

        this.setState({
            fwt: { ...this.state.fwt, show: false }
        }, () => {
            this.setState({
                ewt: {
                    show: true,
                    ewtSummary: recipient.ewtSummary,
                    initialCount: recipient.initialCount
                }
            });
        });
    }

    handleTriggerRexm = (donorId: number, donorAlias: string, donorCenter: string, recipientId: number, recipientAlias: string, recipientCenter: string) => {
        this.setState({
            rexmEmail: {
                show: true,
                donorId,
                donorAlias,
                donorCenter,
                recipientId,
                recipientAlias,
                recipientCenter
            }
        });
    }

    handleRexmYes = () => {
        this.setState({
            rexmEmail: { ...this.state.rexmEmail, show: false }
        }, () => {
            let { donorId, recipientId } = this.state.rexmEmail;

            this.props.showLoading('Triggering REXM, one moment please...').then(() => {
                this.props.sendRexmEmail(donorId, recipientId).then(response => {
                    this.props.hideLoading();

                    if (response.data.success) {
                        toast.success('REXM triggered successully');
                    } else {
                        toast.error('Unable to trigger REXM');
                    }
                });
            });
        });
    }

    handleRexmNo = () => {
        this.setState({
            rexmEmail: { ...this.state.rexmEmail, show: false }
        });
    }

    handleTargetClicked = (recipientId: number) => {
        let exists = this.state.checkedTargets.find(x => x == recipientId) != null;
        let checkedTargets = [...this.state.checkedTargets];

        if (exists)
            checkedTargets = this.state.checkedTargets.filter(x => {
                return x != recipientId;
            });
        else
            checkedTargets.push(recipientId);

        this.setState({
            checkedTargets
        });
    }

    handleChainEndTargetClicked = (recipientId: number) => {
        let exists = this.state.checkedChainEndTargets.find(x => x == recipientId) != null;
        let checkedChainEndTargets = [...this.state.checkedChainEndTargets];

        if (exists) {
            checkedChainEndTargets = this.state.checkedChainEndTargets.filter(x => {
                return x != recipientId;
            });
        } else {
            checkedChainEndTargets.push(recipientId);
        }

        this.setState({
            checkedChainEndTargets
        });
    }

    // handleCheckItems = (checkType: TargetCheckTypeNew, bm3: boolean, suppressHardToMatch: boolean, suppressHighPriorityTargetedChainEnds: boolean, suppressLowPriorityTargetedChainEnds: boolean, suppressUnmatchedPairs: boolean) => {
    //     if (checkType == TargetCheckTypeNew.HardToMatch) {
    //         let list1 = this.state.hardToMatchList.filter(x => x.highPra == true).map(x => x.recipientId);
    //         // let list2 = this.state.targetedChainEnds.filter(x => x.highPra == true).map(x => x.recipientId);
    //         // let list3 = this.state.unmatchedPairs.filter(x => x.highPra == true).map(x => x.recipientId);

    //         let checkedTargets = [...list1];

    //         this.setState({
    //             checkedTargets,
    //             checkedChainEndTargets: [],
    //             // suppressHardToMatch,
    //             // suppressHighPriorityTargetedChainEnds,
    //             // suppressLowPriorityTargetedChainEnds,
    //             // suppressUnmatchedPairs
    //         }, () => {
    //             if (!bm3) {
    //                 document.forms[0].submit();
    //             } else {
    //                 this.gotoBm3(0, false);
    //             }
    //         });
    //     }

    //     if (checkType >= TargetCheckTypeNew.Compatible && checkType <= TargetCheckTypeNew.General) {
    //         let list = this.state.voucherList.filter(x => {
    //             let parts = x.sortOrder.toString().split('.');
    //             let rank = parseInt(parts[0]);

    //             return rank <= checkType || x.pediatric;
    //         }).map(x => x.recipientId);

    //         this.setState({
    //             checkedTargets: [],
    //             checkedChainEndTargets: list,
    //             // suppressHardToMatch,
    //             // suppressHighPriorityTargetedChainEnds,
    //             // suppressLowPriorityTargetedChainEnds,
    //             // suppressUnmatchedPairs
    //         }, () => {
    //             if (!bm3) {
    //                 document.forms[0].submit();
    //             } else {
    //                 this.gotoBm3(0, false);
    //             }
    //         });
    //     }
    // }

    handleUncheckAllTargets = () => {
        this.setState({
            checkedTargets: [],
            checkedChainEndTargets: []
        });
    }

    handleClearTargets = (bm3: boolean) => {
        this.setState({
            checkedTargets: [],
            checkedChainEndTargets: []
        }, () => {
            if (!bm3) {
                document.forms[0].submit();
            } else {
                this.gotoBm3(0, false);
            }
        });
    }

    handleRunScenario = (scenario: IMatchRunScenario, rerun: boolean) => {
        let checkType = scenario != null ? scenario.group.checkType : 0;

        let hardToMatchList = _.cloneDeep(this.state.hardToMatchList).map(x => {
            return { ...x, checked: false };
        });

        let voucherList = _.cloneDeep(this.state.voucherList).map(x => {
            return { ...x, checked: false };
        });

        let pairedPatientList = _.cloneDeep(this.state.pairedPatientList).map(x => {
            return { ...x, checked: false };
        });

        if (checkType == TargetCheckTypeNew.HardToMatch) {
            let list1 = this.state.hardToMatchList.filter(x => x.hardToMatch == true).map(x => x.recipientId);
            let list2 = this.state.voucherList.filter(x => x.hardToMatch == true).map(x => x.recipientId);
            let list3 = this.state.pairedPatientList.filter(x => x.hardToMatch == true).map(x => x.recipientId);

            let checkedTargets = [...list1, ...list3];

            hardToMatchList = hardToMatchList.map(x => {
                x.checked = x.hardToMatch;
                return x;
            });

            voucherList = voucherList.map(x => {
                x.checked = x.hardToMatch;
                return x;
            });

            pairedPatientList = pairedPatientList.map(x => {
                x.checked = x.hardToMatch;
                return x;
            });

            this.setState({
                hardToMatchList,
                voucherList,
                pairedPatientList,
                checkedTargets,
                checkedChainEndTargets: list2,
            }, () => {
                this.gotoBm3(scenario.id, rerun);
            });
        }

        if (checkType >= TargetCheckTypeNew.Compatible && checkType <= TargetCheckTypeNew.Regular) {
            let voucherScenario = this.state.voucherScenarioMap.find(x => x.type == checkType);

            let { min, max } = voucherScenario;

            if (scenario.stalled) {
                min = 0;
            }

            let list = this.state.voucherList.filter(x => {
                return x.majorSort >= min && x.majorSort <= max;
            }).map(x => x.recipientId);

            voucherList = voucherList.map(x => {
                x.checked = x.majorSort >= min && x.majorSort <= max;
                return x;
            });

            this.setState({
                voucherList,
                checkedTargets: [],
                checkedChainEndTargets: list,
            }, () => {
                this.gotoBm3(scenario.id, rerun);
            });
        }

        if (checkType == TargetCheckTypeNew.Open) {
            this.setState({
                hardToMatchList,
                voucherList,
                pairedPatientList,
                checkedTargets: [],
                checkedChainEndTargets: []
            }, () => {
                this.gotoBm3(scenario.id, rerun);
            });
        }

        if (checkType == TargetCheckTypeNew.Future) {
            let generalScenario = this.state.voucherScenarioMap.find(x => x.type == TargetCheckTypeNew.Regular);

            let list = this.state.voucherList.filter(x => {
                let parts = x.sortOrder.toString().split('.');
                let rank = parseInt(parts[0]);

                return rank <= generalScenario.max;
            }).map(x => x.recipientId);

            voucherList = voucherList.map(x => {
                let parts = x.sortOrder.toString().split('.');
                let rank = parseInt(parts[0]);
                let checked = rank <= generalScenario.max;

                x.checked = checked;

                return x;
            });

            this.setState({
                voucherList,
                checkedTargets: [],
                checkedChainEndTargets: list,
            }, () => {
                this.gotoBm3(scenario.id, rerun);
            });
        }

        if (checkType == TargetCheckTypeNew.Loops) {
            this.setState({
                hardToMatchList,
                voucherList,
                pairedPatientList,
                checkedTargets: [],
                checkedChainEndTargets: []
            }, () => {
                this.gotoBm3(scenario.id, rerun);
            });
        }
    }

    handleUpdateSuppress = (type: ListType, value: boolean) => {
        let suppress = { ...this.state.suppress };

        if (type == ListType.HardToMatch) {
            suppress.hardToMatch = value;
        }

        if (type == ListType.Vouchers) {
            suppress.voucher = value;
        }

        if (type == ListType.PairedPatients) {
            suppress.pairedPatient = value;
        }

        this.setState({
            suppress
        });
    }

    handleWaitTime = (waitTime: number) => {
        this.setState({
            waitTime: waitTime
        });

        return waitTime;
    }

    handleFullSizeToggle = () => {
        this.setState({
            fullSize: !this.state.fullSize
        });
    }

    handleExport = () => {
        let dateStamp = this.getTimeDateString();
        let fileName = 'targets-data-' + dateStamp + '.xlsx'

        let spreadsheets = [];

        let sheetNames = [
            'Hard to Match',
            'Voucher',
            'Paired Patients'
        ]

        for (let i = 0; i < this.state.gridApis.length; i++) {
            let data = this.state.gridApis[i].getSheetDataForExcel({
                sheetName: sheetNames[i],
            });

            spreadsheets.push(data);
        }

        exportMultipleSheetsAsExcel({
            data: spreadsheets,
            fileName
        });
    }

    handleShowMortalityBreakdown = (type: number, recipient: ITargetItem) => {
        this.setState({
            mortalityBreakdown: {
                show: true,
                recipientAlias: recipient.recipientAlias,
                data: recipient.mortalityCalculations
            }
        })
    }

    handleMortalityBreakdownClose = () => {
        this.setState({
            mortalityBreakdown: {
                show: false,
                recipientAlias: '',
                data: null
            }
        })
    }

    render = () => {
        return (
            <TargetsContentWrapper>
                <Tabs tabKey='TARGET-NEW' subTabKey='' counts={null} user={this.props.user} />

                <div style={{ position: 'absolute', top: 0, right: 0 }}>
                    <Button bsSize='xs' bsStyle='success' onClick={this.handleExport}>Export CSV</Button>
                </div>

                <BestMatchOptions
                    groups={this.state.groups}
                    scenarios={this.state.scenarios}
                    onClear={this.handleClearTargets}
                    onRunScenario={this.handleRunScenario}
                />

                <PatientList
                    list={this.state.hardToMatchList}
                    suppress={this.state.suppress.hardToMatch}
                    title='P2 Hard to Match'
                    type={ListType.HardToMatch}
                    className='hard-to-match'
                    checkedTargets={this.state.checkedTargets}
                    checkedChainEndTargets={this.state.checkedChainEndTargets}
                    fullSize={this.state.fullSize}
                    voucherScenarioMap={this.state.voucherScenarioMap}
                    onTargetClicked={this.handleTargetClicked}
                    onUpdateSuppress={this.handleUpdateSuppress}
                    onShowEwt={this.handleShowEwt}
                    onShowFwt={this.handleShowFwt}
                    onTriggerRexm={this.handleTriggerRexm}
                    onClear={this.handleUncheckAllTargets}
                    onFullSizeToggle={this.handleFullSizeToggle}
                    onGridReady={this.onGridReady}
                    onShowMortalityBreakdown={this.handleShowMortalityBreakdown}
                />

                <PatientList
                    list={this.state.voucherList}
                    suppress={this.state.suppress.voucher}
                    title='P3 Voucher'
                    type={ListType.Vouchers}
                    className='voucher'
                    checkedTargets={this.state.checkedTargets}
                    checkedChainEndTargets={this.state.checkedChainEndTargets}
                    fullSize={this.state.fullSize}
                    voucherScenarioMap={this.state.voucherScenarioMap}
                    onTargetClicked={this.handleTargetClicked}
                    onUpdateSuppress={this.handleUpdateSuppress}
                    onShowEwt={this.handleShowEwt}
                    onShowFwt={this.handleShowFwt}
                    onTriggerRexm={this.handleTriggerRexm}
                    onClear={this.handleUncheckAllTargets}
                    onFullSizeToggle={this.handleFullSizeToggle}
                    onGridReady={this.onGridReady}
                    onShowMortalityBreakdown={this.handleShowMortalityBreakdown}
                />

                <PatientList
                    list={this.state.pairedPatientList}
                    suppress={this.state.suppress.pairedPatient}
                    title='P4 Paired Patients'
                    type={ListType.PairedPatients}
                    className='paired-patients'
                    waitTime={this.state.waitTime}
                    checkedTargets={this.state.checkedTargets}
                    checkedChainEndTargets={this.state.checkedChainEndTargets}
                    fullSize={this.state.fullSize}
                    voucherScenarioMap={this.state.voucherScenarioMap}
                    onTargetClicked={this.handleTargetClicked}
                    onUpdateSuppress={this.handleUpdateSuppress}
                    onShowEwt={this.handleShowEwt}
                    onShowFwt={this.handleShowFwt}
                    onTriggerRexm={this.handleTriggerRexm}
                    onClear={this.handleUncheckAllTargets}
                    onFullSizeToggle={this.handleFullSizeToggle}
                    onGridReady={this.onGridReady}
                    onShowMortalityBreakdown={this.handleShowMortalityBreakdown}
                />

                <EwtDetails
                    show={this.state.ewt.show}
                    summaryData={this.state.ewt.ewtSummary}
                    initialCount={this.state.ewt.initialCount}
                    donorsPerMonthByAbo={this.state.donorsPerMonthByAbo}
                    onClose={this.handleEwtClose}
                />

                <TriggerRexm
                    show={this.state.rexmEmail.show}
                    donorAlias={this.state.rexmEmail.donorAlias}
                    donorCenter={this.state.rexmEmail.donorCenter}
                    recipientAlias={this.state.rexmEmail.recipientAlias}
                    recipientCenter={this.state.rexmEmail.recipientCenter}
                    onYes={this.handleRexmYes}
                    onNo={this.handleRexmNo}
                />

                {/* put mortality calc here */}
                <MortalityBreakdown
                    show={this.state.mortalityBreakdown.show}
                    recipientAlias={this.state.mortalityBreakdown.recipientAlias}
                    data={this.state.mortalityBreakdown.data}
                    onClose={this.handleMortalityBreakdownClose}
                />

                <FwlDetailsModal
                    show={this.state.fwt.show}
                    summaryData={this.state.fwt.fwtSummary}
                    showLink={true}
                    onOpenEWTModal={this.handleOpenEWTPage}
                    onClose={this.handleFwtClose}
                />

                <form method='post' action={__BM_URL__} target='_blank'>
                    <input type='hidden' name='token' value={this.props.token} />
                    <input type='hidden' name='target[]' value={this.state.checkedTargets.length == 0 ? null : this.state.checkedTargets.join(',')} />
                    <input type='hidden' name='chainEndTarget[]' value={this.state.checkedChainEndTargets.length == 0 ? null : this.state.checkedChainEndTargets.join(',')} />
                </form>
            </TargetsContentWrapper>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        token: state.auth.tokenHex,
        user: state.app.user
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getAllNew: () => {
            return dispatch(TargetActionCreators.getAllNew());
        },
        getDonorsPerMonthByAbo: () => {
            return dispatch(TargetActionCreators.getDonorsPerMonthByAbo());
        },
        getScenariosNew: () => {
            return dispatch(MatchingActionCreators.getScenariosNew());
        },
        sendRexmEmail: (donorId, recipientId) => {
            return dispatch(TargetActionCreators.sendRexmEmail(donorId, recipientId));
        },
        updateClc: () => {
            return dispatch(TargetActionCreators.updateClc());
        }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(Target);